// Module
var code = "<tr class=linkRow data-hash=\"<%- hash %>\"> <td><%- name %></td> <td><%- hash %></td> <td><%- leagueName %></td> <td><%- vertical %></td> <td><%- createdDate %></td> </tr> ";
// Exports
module.exports = code;